<template>
  <saveModelDialogComponent
    :saveModelDialog="saveModelDialog"
    :modelName="modelName"
    @changeModelName="(e) => (modelName = e)"
    @changeModelDialog="(e) => (saveModelDialog = e)"
    @submitSetup="submitSetup()"
  />
  <div v-if="!$store.state.authenticate.isAuthenticated">
    <MessageCard
      :displayMessage="'This feature is only available for logged-in users. Please log in to access it.'"
      :buttonText="'Login'"
      :buttonRoute="'/login'"
      :buttonQuery="
        isSaveModelPage ? 'CustomSignalProV2Save' : 'CustomSignalProV2'
      "
    />
  </div>
  <div v-else>
    <div
      v-if="this.$store.state.packages.packageStatus?.current_package == null"
    >
      <MessageCard
        :displayMessage="'This feature is only avilable for paid subscriber. Please subscribe the package'"
        :buttonText="'Subscribe Now'"
        :buttonRoute="'/payment'"
      />
    </div>
    <q-card>
      <div>
        <!-- BuySell Setup -->
        <q-card-section class="row q-px-xs">
          <div class="col-12 col-md-2 q-pa-sm">
            <q-select
              outline
              :disable="setDataFromBackend"
              v-model="setup_type"
              :options="[props_setup_type, 'sell', 'both']"
              dense
              label="Choose Setup"
              single
              class="q-mx-sm"
              :menu-absolute="true"
            >
              <q-tooltip class="bg-primary text-white"
                >Choose setup type</q-tooltip
              >
            </q-select>
          </div>
          <div class="col-12 col-md-2 q-pa-sm">
            <q-select
              outline
              :disable="setDataFromBackend"
              v-model="selectedSector"
              :options="optionSectors"
              dense
              label="Choose sector"
              single
              input-debounce="0"
              option-label="name"
              option-value="symbol"
              class="q-mx-sm ellipsis"
              :menu-absolute="true"
            />
          </div>
          <q-space />
          <div class="col-12 col-md-2 q-pa-sm">
            <q-input
              v-if="backTest"
              dense
              v-model="from_date"
              mask="date"
              :rules="['date']"
              hint="From Date"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date v-model="from_date">
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
              <q-tooltip class="bg-primary text-white"
                >Select from date</q-tooltip
              >
            </q-input>
          </div>
          <div class="col-12 col-md-2 q-pa-sm">
            <q-input
              v-if="backTest"
              dense
              v-model="to_date"
              mask="date"
              :rules="['date']"
              hint="To Date"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date v-model="to_date">
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
              <q-tooltip class="bg-primary text-white"
                >Select to date</q-tooltip
              >
            </q-input>
          </div>
        </q-card-section>

        <!-- Buy Setup -->
        <q-card-section
          class="q-px-xs"
          :class="this.$q.dark.mode === true ? '' : 'text-primary'"
          v-if="setup_type === props_setup_type || setup_type === 'both'"
        >
          <div class="q-pa-xs text-subtitle1 text-bold">Buy Setup</div>

          <q-card flat bordered>
            <!-- Select Indicator -->
            <q-card-section class="text-left">
              <div class="text-caption text-weight-medium">
                Select Indicator
              </div>
              <!-- Start Buy CheckBox -->
              <div class="q-gutter-md">
                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.rsi"
                  color="blue-5"
                  keep-color
                  label="RSI"
                >
                  <q-tooltip class="bg-primary"
                    >Relative Strength Index</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.rsi_crossover"
                  color="blue-5"
                  keep-color
                  label="RSI Crossover"
                >
                  <q-tooltip class="bg-primary"
                    >Relative Strength Index Crossover</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.sma"
                  color="blue-5"
                  keep-color
                  label="SMA"
                >
                  <q-tooltip class="bg-primary"
                    >Simple Moving Average</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.sma_crossover"
                  color="blue-5"
                  keep-color
                  label="SMA Crossover"
                >
                  <q-tooltip class="bg-primary"
                    >Simple Moving Average Crossover</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.macd"
                  color="blue-5"
                  keep-color
                  label="MACD"
                >
                  <q-tooltip class="bg-primary"
                    >Moving Average Convergence/Divergence</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.ema"
                  color="blue-5"
                  keep-color
                  label="EMA"
                >
                  <q-tooltip class="bg-primary"
                    >Exponential Moving Average</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.ema_crossover"
                  color="blue-5"
                  keep-color
                  label="EMA Crossover"
                >
                  <q-tooltip class="bg-primary"
                    >Exponential Moving Average Crossover</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.supertrend"
                  color="blue-5"
                  keep-color
                  label="Supertrend"
                >
                  <q-tooltip class="bg-primary">Supertrend</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.di"
                  color="blue-5"
                  keep-color
                  label="Directional Movement"
                >
                  <q-tooltip class="bg-primary">Directional Movement</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  disable
                  v-model="customSignalDataBuy.psar"
                  color="blue-5"
                  keep-color
                  label="Parabolic SAR"
                >
                  <q-tooltip class="bg-primary">Parabolic SAR</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.bb"
                  color="blue-5"
                  keep-color
                  label="Bollinger Bands"
                >
                  <q-tooltip class="bg-primary">Bollinger Bands</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.bb_squeeze"
                  color="blue-5"
                  keep-color
                  label="Bollinger Bands Squeeze"
                >
                  <q-tooltip class="bg-primary"
                    >Bollinger Bands Squeeze</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.stochrsi"
                  color="blue-5"
                  keep-color
                  label="Stochastic RSI"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Stochastic RSI</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  disable
                  v-model="customSignalDataBuy.kc"
                  color="blue-5"
                  keep-color
                  label="Keltner Channels"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Keltner Channels</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.mfi"
                  color="blue-5"
                  keep-color
                  label="Money Flow Index"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Money Flow Index</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataBuy.ao"
                  color="blue-5"
                  keep-color
                  label="Awesome Oscillator"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Awesome Oscillator</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  disable
                  v-model="customSignalDataBuy.kama"
                  color="blue-5"
                  keep-color
                  label="Adaptive Moving Average"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary"
                    >Adaptive Moving Average</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  v-model="customSignalDataBuy.ichimoku"
                  :disable="setDataFromBackend"
                  color="blue-5"
                  keep-color
                  label="Ichimoku cloud"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Ichimoku Cloud</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  v-model="customSignalDataBuy.accumulation_distribution"
                  :disable="setDataFromBackend"
                  color="blue-5"
                  keep-color
                  label="Accumulation Distribution"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary"
                    >Accumulation Distribution</q-tooltip
                  >
                </q-checkbox>
              </div>
              <!-- End Buy CheckBox -->
            </q-card-section>
            <q-separator />

            <!-- Start Buy Form -->
            <q-card-section v-if="customSignalDataBuy.rsi" class="q-pa-xs">
              <RsiForm
                :style="cursorPointerNone"
                :disable="setDataFromBackend"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.rsi"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('rsi') > 0"
                @formData="
                  (eventData) => {
                    formsRsi = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataBuy.rsi_crossover"
            >
              <RsiCrossoverForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.rsi_crossover"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('rsi_crossover') > 0"
                @formData="
                  (eventData) => {
                    formsRsiCrossover = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.sma">
              <SmaForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.sma"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('sma') > 0"
                @formData="
                  (eventData) => {
                    formsSma = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataBuy?.sma_crossover"
            >
              <SmaCrossoverForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.sma_crossover"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('sma_crossover') > 0"
                @formData="
                  (eventData) => {
                    formsSmaCrossover = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.macd">
              <MacdForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.macd"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('macd') > 0"
                @formData="
                  (eventData) => {
                    formsMacd = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.ema">
              <EmaForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.ema"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('ema') > 0"
                @formData="
                  (eventData) => {
                    formsEma = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataBuy.ema_crossover"
            >
              <EmaCrossoverForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.ema_crossover"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('ema_crossover') > 0"
                @formData="
                  (eventData) => {
                    formsEmaCrossover = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataBuy.supertrend"
            >
              <SupertrendForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.supertrend"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('supertrend') > 0"
                @formData="
                  (eventData) => {
                    formsSupertrend = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.di">
              <DIForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.di"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('di') > 0"
                @formData="
                  (eventData) => {
                    formsDI = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.psar">
              <PsarForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.psar"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('psar') > 0"
                @formData="
                  (eventData) => {
                    formsParabolicSar = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.bb">
              <BBForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.bb"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('bb') > 0"
                @formData="
                  (eventData) => {
                    formsBB = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataBuy.bb_squeeze"
            >
              <BBFormSqueeze
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.bb_squeeze"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('bb') > 0"
                @formData="
                  (eventData) => {
                    formsBBSqueeze = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.stochrsi">
              <StochasticRsiForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :buySellType="'buy'"
                :setup_data="buy_setup_data?.stochrsi"
                :isMoreThan="findIndexByKey('stochrsi') > 0"
                @formData="
                  (eventData) => {
                    formsStochasticRsi = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.kc">
              <KCForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :buySellType="'buy'"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="buy_setup_data?.kc"
                :isMoreThan="findIndexByKey('kc') > 0"
                @formData="
                  (eventData) => {
                    formsKeltner = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.mfi">
              <MoneyFlowIndexForm
                :style="cursorPointerNone"
                :setDataFromBackend="setDataFromBackend"
                :buySellType="'buy'"
                :setup_data="buy_setup_data?.mfi"
                :isBackTest="backTest"
                :isMoreThan="findIndexByKey('mfi') > 0"
                @formData="
                  (eventData) => {
                    formsMoneyFlowIndex = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.ao">
              <AwesomeOscillatorForm
                :style="cursorPointerNone"
                :setDataFromBackend="setDataFromBackend"
                :buySellType="'buy'"
                :setup_data="buy_setup_data?.ao"
                :isBackTest="backTest"
                :isMoreThan="findIndexByKey('ao') > 0"
                @formData="
                  (eventData) => {
                    formsAwesomeOscillatorIndex = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.kama">
              <KaufmanAdaptiveMovingAverageForm
                :isBackTest="backTest"
                :isMoreThan="findIndexByKey('kama') > 0"
                @formData="
                  (eventData) => {
                    formsKaufmanAdaptiveMovingAverage = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataBuy.ichimoku">
              <IchimokuCloudForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :isMoreThan="findIndexByKey('ichimoku') > 0"
                :buySellType="'buy'"
                @formData="
                  (eventData) => {
                    formsIchimoku = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataBuy.accumulation_distribution"
            >
              <AccumulationDistributionForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :buySellType="'buy'"
                :isMoreThan="findIndexByKey('accumulation_distribution') > 0"
                @formData="
                  (eventData) => {
                    formsAccumulationDistribution = eventData;
                  }
                "
              />
            </q-card-section>
            <!-- End Buy Form -->
          </q-card>
        </q-card-section>

        <!-- Sell Setup -->
        <q-card-section
          class="q-px-xs"
          v-if="setup_type === 'sell' || setup_type === 'both'"
          :class="this.$q.dark.mode === true ? '' : 'text-primary'"
        >
          <div class="q-pa-xs text-subtitle1 text-bold">Sell Setup</div>

          <q-card flat bordered>
            <q-card-section class="text-left q-px-xs">
              <div class="text-caption text-weight-medium">
                Select Indicator
              </div>

              <div class="q-gutter-md">
                <!-- Start Sell CheckBox -->
                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.rsi"
                  color="blue-5"
                  keep-color
                  label="RSI"
                >
                  <q-tooltip class="bg-primary"
                    >Relative Strength Index</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.rsi_crossover"
                  color="blue-5"
                  keep-color
                  label="RSI Crossover"
                >
                  <q-tooltip class="bg-primary"
                    >Relative Strength Index Crossover</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.sma"
                  color="blue-5"
                  keep-color
                  label="SMA"
                >
                  <q-tooltip class="bg-primary"
                    >Simple Moving Average</q-tooltip
                  >
                </q-checkbox>
                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.sma_crossover"
                  color="blue-5"
                  keep-color
                  label="SMA Crossover"
                >
                  <q-tooltip class="bg-primary"
                    >Simple Moving Average Crossover</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.macd"
                  color="blue-5"
                  keep-color
                  label="MACD"
                >
                  <q-tooltip class="bg-primary"
                    >Moving Average Convergence/Divergence</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.ema"
                  color="blue-5"
                  keep-color
                  label="EMA"
                >
                  <q-tooltip class="bg-primary"
                    >Exponential Moving Average</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.ema_crossover"
                  color="blue-5"
                  keep-color
                  label="EMA Crossover"
                >
                  <q-tooltip class="bg-primary"
                    >Exponential Moving Average Crossover</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.supertrend"
                  color="blue-5"
                  keep-color
                  label="Supertrend"
                >
                  <q-tooltip class="bg-primary">Supertrend</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.di"
                  color="blue-5"
                  keep-color
                  label="Directional Movement"
                >
                  <q-tooltip class="bg-primary">Directional Movement</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  disable
                  v-model="customSignalDataSell.psar"
                  color="blue-5"
                  keep-color
                  label="Parabolic SAR"
                >
                  <q-tooltip class="bg-primary">Parabolic SAR</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.bb"
                  color="blue-5"
                  keep-color
                  label="Bollinger Bands"
                >
                  <q-tooltip class="bg-primary">Bollinger Bands</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.stochrsi"
                  color="blue-5"
                  keep-color
                  label="Stochastic RSI"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Stochastic RSI</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  disable
                  v-model="customSignalDataSell.kc"
                  color="blue-5"
                  keep-color
                  label="Keltner Channels"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Keltner Channels</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.mfi"
                  color="blue-5"
                  keep-color
                  label="Money Flow Index"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Money Flow Index</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  :disable="setDataFromBackend"
                  v-model="customSignalDataSell.ao"
                  color="blue-5"
                  keep-color
                  label="Awesome Oscillaotr"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Awesome Oscillator</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  disable
                  v-model="customSignalDataSell.kama"
                  color="blue-5"
                  keep-color
                  label="Adaptive Moving Average"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary"
                    >Adaptive moving Average</q-tooltip
                  >
                </q-checkbox>

                <q-checkbox
                  v-model="customSignalDataSell.ichimoku"
                  color="blue-5"
                  keep-color
                  label="Ichimoku Cloud"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary">Ichimoku Cloud</q-tooltip>
                </q-checkbox>

                <q-checkbox
                  v-model="customSignalDataSell.accumulation_distribution"
                  :disable="setDataFromBackend"
                  color="blue-5"
                  keep-color
                  label="Accumulation Distribution"
                >
                  <sup
                    class="text-bold text-caption live q-pl-x"
                    style="color: #1976d2"
                  >
                    New
                  </sup>
                  <q-tooltip class="bg-primary"
                    >Accumulation Distribution</q-tooltip
                  >
                </q-checkbox>
                <!-- End Sell Checkbox -->
              </div>
            </q-card-section>
            <q-separator />

            <!-- Start Sell Form -->
            <q-card-section class="q-px-xs" v-if="customSignalDataSell.rsi">
              <RsiForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.rsi"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('rsi') > 0"
                @formData="
                  (eventData) => {
                    formsRsiSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataSell.rsi_crossover"
            >
              <RsiCrossoverForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.rsi_crossover"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('rsi_crossover') > 0"
                @formData="
                  (eventData) => {
                    formsRsiCrossoverSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.sma">
              <SmaForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.sma"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('sma') > 0"
                @formData="
                  (eventData) => {
                    formsSmaSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataSell.sma_crossover"
            >
              <SmaCrossoverForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.sma_crossover"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('sma_crossover') > 0"
                @formData="
                  (eventData) => {
                    formsSmaCrossoverSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.macd">
              <MacdForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.macd"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('macd') > 0"
                @formData="
                  (eventData) => {
                    formsMacdSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.ema">
              <EmaForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.ema"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('ema') > 0"
                @formData="
                  (eventData) => {
                    formsEmaSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataSell.ema_crossover"
            >
              <EmaCrossoverForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.ema_crossover"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('ema_crossover') > 0"
                @formData="
                  (eventData) => {
                    formsEmaCrossoverSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataSell.supertrend"
            >
              <SupertrendForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.supertrend"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('supertrend') > 0"
                @formData="
                  (eventData) => {
                    formsSupertrendSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.di">
              <DIForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.rsi"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('di') > 0"
                @formData="
                  (eventData) => {
                    formsDISell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.psar">
              <PsarForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :buySellType="'sell'"
                :setup_data="sell_setup_data?.psar"
                :isMoreThan="findIndexByKeySell('psar') > 0"
                @formData="
                  (eventData) => {
                    formsParabolicSarSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.bb">
              <BBForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.bb"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKeySell('bb') > 0"
                @formData="
                  (eventData) => {
                    formsBBSqueezeSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataSell.stochrsi"
            >
              <StochasticRsiForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :buySellType="'sell'"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.stochrsi"
                :isMoreThan="findIndexByKeySell('stochrsi') > 0"
                @formData="
                  (eventData) => {
                    formsStochasticRsiSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.kc">
              <KCForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :buySellType="'sell'"
                :setDataFromBackend="setDataFromBackend"
                :setup_data="sell_setup_data?.kc"
                :isMoreThan="findIndexByKeySell('kc') > 0"
                @formData="
                  (eventData) => {
                    formsKeltnerSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.mfi">
              <MoneyFlowIndexForm
                :style="cursorPointerNone"
                :setDataFromBackend="setDataFromBackend"
                :buySellType="'sell'"
                :setup_data="buy_setup_data?.mfi"
                :isBackTest="backTest"
                :isMoreThan="findIndexByKey('mfi') > 0"
                @formData="
                  (eventData) => {
                    formsMoneyFlowIndexSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.ao">
              <AwesomeOscillatorForm
                :style="cursorPointerNone"
                :setDataFromBackend="setDataFromBackend"
                :buySellType="'sell'"
                :setup_data="buy_setup_data?.ao"
                :isBackTest="backTest"
                :isMoreThan="findIndexByKey('ao') > 0"
                @formData="
                  (eventData) => {
                    formsAwesomeOscillatorIndexSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section class="q-px-xs" v-if="customSignalDataSell.kama">
              <KaufmanAdaptiveMovingAverageForm
                :isBackTest="backTest"
                :isMoreThan="findIndexByKey('kama') > 0"
                @formData="
                  (eventData) => {
                    formsKaufmanAdaptiveMovingAverageSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataSell.ichimoku"
            >
              <IchimokuCloudForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKey('ichimoku') > 0"
                @formData="
                  (eventData) => {
                    formsIchimokuSell = eventData;
                  }
                "
              />
            </q-card-section>

            <q-card-section
              class="q-px-xs"
              v-if="customSignalDataSell.accumulation_distribution"
            >
              <AccumulationDistributionForm
                :style="cursorPointerNone"
                :isBackTest="backTest"
                :buySellType="'sell'"
                :isMoreThan="findIndexByKey('accumulation_distribution') > 0"
                @formData="
                  (eventData) => {
                    formsAccumulationDistributionSell = eventData;
                  }
                "
              />
            </q-card-section>

            <!-- End Sell Form -->
          </q-card>
        </q-card-section>

        <div class="q-pa-md q-gutter-md">
          <q-toggle
            v-model="visible"
            :class="this.$q.dark.mode ? '' : 'text-primary'"
            class="text-bold"
            label="Fundamental Scan Pro"
          >
            <q-tooltip>toggle to fundamental scan</q-tooltip>
          </q-toggle>
          <FundamentalScan
            v-show="visible"
            @emitData="
              (eventData) => {
                fundamentalScanData = eventData.map((i) => i.symbol);
              }
            "
          />
          <q-checkbox
            :disable="setDataFromBackend && !editModel"
            v-model="above_avg_vol"
            color="blue-5"
            keep-color
            label="With Above Average Volume"
          >
            <q-tooltip class="bg-primary">Above Average Volume</q-tooltip>
          </q-checkbox>
        </div>

        <div class="row justify-center q-pa-md">
          <div v-if="setDataFromBackend == false || editModel">
            <q-btn
              :label="
                !isSaveModelPage && !setDataFromBackend
                  ? 'Run Model'
                  : 'Save Model'
              "
              color="primary"
              @click="
                !isSaveModelPage ? submitSetup() : (saveModelDialog = true)
              "
            />
          </div>
        </div>
      </div>
    </q-card>
  </div>
</template>

<script>
import { ref, computed, watch, watchEffect, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import useUtils from "src/use/utils";
import MessageCard from "src/components/MessageCard.vue";
import useCustomsignal from "src/use/customsignal";
import SmaForm from "src/components/CustomSignalProV2Components/SmaForm.vue";
import SmaCrossoverForm from "src/components/CustomSignalProV2Components/SmaCrossoverForm.vue";
import EmaForm from "src/components/CustomSignalProV2Components/EmaForm.vue";
import EmaCrossoverForm from "src/components/CustomSignalProV2Components/EmaCrossoverForm.vue";
import RsiForm from "src/components/CustomSignalProV2Components/RsiForm.vue";
import RsiCrossoverForm from "src/components/CustomSignalProV2Components/RsiCrossoverForm.vue";
import MacdForm from "src/components/CustomSignalProV2Components/MacdForm.vue";
import SupertrendForm from "src/components/CustomSignalProV2Components/SupertrendForm.vue";
import DIForm from "src/components/CustomSignalProV2Components/DIForm.vue";
import PsarForm from "src/components/CustomSignalProV2Components/PsarForm.vue";
import BBForm from "src/components/CustomSignalProV2Components/BBForm.vue";
import BBFormSqueeze from "src/components/CustomSignalProV2Components/BBFormSqueeze.vue";
import StochasticRsiForm from "src/components/CustomSignalProV2Components/StochasticRsiForm.vue";
import KCForm from "src/components/CustomSignalProV2Components/KCForm.vue";
import MoneyFlowIndexForm from "src/components/CustomSignalProV2Components/MoneyFlowIndexForm.vue";
import AwesomeOscillatorForm from "src/components/CustomSignalProV2Components/AwesomeOscillatorForm.vue";
import KaufmanAdaptiveMovingAverageForm from "src/components/CustomSignalProV2Components/KaufmanAdaptiveMovingAverageForm.vue";
import saveModelDialogComponent from "src/components/CustomSignalProV2Components/SaveModelDialog.vue";
import IchimokuCloudForm from "src/components/CustomSignalProV2Components/IchimokuCloudForm.vue";
import AccumulationDistributionForm from "src/components/CustomSignalProV2Components/AccumulationDistributionForm.vue";

import FundamentalScan from "src/components/FundamentalScanPro/FundamentalScanProComponents.vue";

export default {
  name: "CustomSignalProV2",

  components: {
    MessageCard,
    SmaForm,
    SmaCrossoverForm,
    EmaForm,
    EmaCrossoverForm,
    RsiForm,
    RsiCrossoverForm,
    MacdForm,
    SupertrendForm,
    DIForm,
    PsarForm,
    BBForm,
    BBFormSqueeze,
    StochasticRsiForm,
    KCForm,
    MoneyFlowIndexForm,
    AwesomeOscillatorForm,
    KaufmanAdaptiveMovingAverageForm,
    saveModelDialogComponent,
    IchimokuCloudForm,
    FundamentalScan,
    AccumulationDistributionForm,
  },
  props: {
    model_name: {
      type: String,
    },
    model_id: {
      type: Number,
    },
    editModel: {
      type: Boolean,
      default: false,
    },
    backTest: {
      type: Boolean,
      default: false,
    },
    setDataFromBackend: { type: Boolean, default: false },
    props_setup_type: { type: String, default: "buy" },
    buy_setup_data: { type: Object },
    sell_setup_data: { type: Object },
    buy_indicators: { type: Array, default: () => [] },
    sell_indicators: { type: Array, default: () => [] },
    v2: { type: Boolean, default: false },
    isSaveModelPage: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Custom Signal Pro V2",
    },
    above_average_volume: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: [
    "buySignals",
    "sellSignals",
    "indicators",
    "submitBackTest",
    "customSignalProV2",
    "editModel",
    "fundamentalScan",
    "isFundamentalScan",
  ],
  setup(props, context) {
    const $q = useQuasar();
    const store = useStore();
    const { customSignalProV2New } = useCustomsignal();
    const { utilsOptionSectors } = useUtils();
    const savedCustomSignalPro = ref([]);
    const avaliablePackageList = ref([]);
    const setup_type = ref("");
    const asOfDate = ref("");
    const to_date = ref("");
    const from_date = ref("");
    const signal_type = ref("Single");
    const symbol = ref(null);
    const loading = ref(true);
    const optionSectors = ref(utilsOptionSectors());
    const selectedSector = ref(optionSectors.value[0]);
    const above_avg_vol = ref(false);

    const initializeCustomSignalData = () => ({
      rsi: true,
      rsi_crossover: false,
      sma: false,
      sma_crossover: false,
      macd: false,
      ema: false,
      ema_crossover: false,
      supertrend: false,
      di: false,
      psar: false,
      bb: false,
      bb_squeeze: false,
      kc: false,
      stochrsi: false,
      mfi: false,
      ao: false,
      kama: false,
      ichimoku: false,
      accumulation_distribution: false,
    });

    const customSignalDataBuy = ref(initializeCustomSignalData());
    const customSignalDataSell = ref(initializeCustomSignalData());

    const customTableData = ref({});
    const customBuySignal = ref([]);
    const customSellSignal = ref([]);

    const fundamentalScanData = ref([]);
    const visible = ref(false);

    const formsRsi = ref([]);
    const formsRsiCrossover = ref([]);
    const formsEma = ref([]);
    const formsEmaCrossover = ref([]);
    const formsSma = ref([]);
    const formsSmaCrossover = ref([]);
    const formsMacd = ref([]);
    const formsSupertrend = ref([]);
    const formsDI = ref([]);
    const formsParabolicSar = ref([]);
    const formsBB = ref([]);
    const formsBBSqueeze = ref([]);
    const formsStochasticRsi = ref([]);
    const formsMoneyFlowIndex = ref([]);
    const formsAwesomeOscillatorIndex = ref([]);
    const formsKaufmanAdaptiveMovingAverage = ref([]);
    const formsKeltner = ref([]);
    const formsIchimoku = ref([]);
    const formsAccumulationDistribution = ref([]);

    const formsRsiSell = ref([]);
    const formsRsiCrossoverSell = ref([]);
    const formsEmaSell = ref([]);
    const formsEmaCrossoverSell = ref([]);
    const formsSmaSell = ref([]);
    const formsSmaCrossoverSell = ref([]);
    const formsMacdSell = ref([]);
    const formsSupertrendSell = ref([]);
    const formsDISell = ref([]);
    const formsParabolicSarSell = ref([]);
    const formsBBSell = ref([]);
    const formsBBSqueezeSell = ref([]);
    const formsMoneyFlowIndexSell = ref([]);
    const formsAwesomeOscillatorIndexSell = ref([]);
    const formsStochasticRsiSell = ref([]);
    const formsKaufmanAdaptiveMovingAverageSell = ref([]);
    const formsIchimokuSell = ref([]);
    const formsKeltnerSell = ref([]);
    const formsAccumulationDistributionSell = ref([]);

    let modelName = ref("");
    let saveModelDialog = ref(false);
    let savedCustomSignalData = ref("");
    let miniumTimeperiod = ref("daily");

    const getAsof = () => {
      asOfDate.value = store.state.market.asOf.replaceAll("/", "-");
      to_date.value = asOfDate.value;
      from_date.value = new Date(
        new Date(asOfDate.value).setFullYear(
          new Date(asOfDate.value).getFullYear() - 1
        )
      )
        .toISOString()
        .substring(0, 10);
    };

    watch([() => props.model_id], (newVal, oldVal) => {
      if (props.setDataFromBackend) {
        setup_type.value = props.props_setup_type;
        above_avg_vol.value = props.above_average_volume;
        for (let i in customSignalDataBuy.value) {
          customSignalDataBuy.value[i] = false;
        }
        for (let i in customSignalDataSell.value) {
          customSignalDataSell.value[i] = false;
        }

        props.buy_indicators.forEach((i) => {
          customSignalDataBuy.value[i] = true;
        });
        props.sell_indicators.forEach((i) => {
          customSignalDataSell.value[i] = true;
        });
      }
    });

    watchEffect(() => {
      context.emit("isFundamentalScan", visible.value);
      if (visible.value) {
        context.emit("fundamentalScan", fundamentalScanData.value);
      }
    });

    onMounted(() => {
      setup_type.value = props.props_setup_type;
      above_avg_vol.value = props.above_average_volume;
      if (props.setDataFromBackend) {
        for (let i in customSignalDataBuy.value) {
          customSignalDataBuy.value[i] = false;
        }
        for (let i in customSignalDataSell.value) {
          customSignalDataSell.value[i] = false;
        }

        props.buy_indicators.forEach((i) => {
          customSignalDataBuy.value[i] = true;
        });
        props.sell_indicators.forEach((i) => {
          customSignalDataSell.value[i] = true;
        });
      }

      if (store.state.market.asOf) {
        getAsof();
      } else {
        store.dispatch("market/marketStatusNew").then(() => {
          getAsof();
        });
      }
    });

    const generateOutputData = (customSignalData, formsObj, formVars) => {
      const forms = {};
      formVars.forEach((varName) => {
        if (customSignalData.value[varName]) {
          forms[varName] = customSignalData.value[varName]
            ? formsObj[varName]
            : [];
        }
      });

      const timePeriods = Array.from(
        new Set(
          Object.values(forms).flatMap((form) =>
            form.value ? form.value.map((entry) => entry.time_period) : []
          )
        )
      );

      return {
        indicators: forms,
        time_period: timePeriods,
        from: from_date.value,
        to: to_date.value,
        setup_sector_id: selectedSector.value?.id,
      };
    };
    const cursorPointerNone = computed(() => {
      return props.setDataFromBackend && !props.editModel
        ? { "pointer-events": "none" }
        : "";
    });
    const outputData = computed(() => {
      let obj = {
        rsi: formsRsi.value,
        rsi_crossover: formsRsiCrossover.value,
        sma: formsSma.value,
        sma_crossover: formsSmaCrossover.value,
        macd: formsMacd.value,
        ema: formsEma.value,
        ema_crossover: formsEmaCrossover.value,
        supertrend: formsSupertrend.value,
        di: formsDI.value,
        psar: formsParabolicSar.value,
        bb: formsBB.value,
        bb_squeeze: formsBBSqueeze.value,
        stochrsi: formsStochasticRsi.value,
        mfi: formsMoneyFlowIndex.value,
        ao: formsAwesomeOscillatorIndex.value,
        kc: formsKeltner.value,
        kama: formsKaufmanAdaptiveMovingAverage.value,
        ichimoku: formsIchimoku.value,
        accumulation_distribution: formsAccumulationDistribution.value,
      };
      return generateOutputData(customSignalDataBuy, obj, Object.keys(obj));
    });

    const outputSellData = computed(() => {
      let obj = {
        rsi: formsRsiSell.value,
        rsi_crossover: formsRsiCrossoverSell.value,
        sma: formsSmaSell.value,
        sma_crossover: formsSmaCrossoverSell.value,
        macd: formsMacdSell.value,
        ema: formsEmaSell.value,
        ema_crossover: formsEmaCrossoverSell.value,
        supertrend: formsSupertrendSell.value,
        di: formsDISell.value,
        psar: formsParabolicSarSell.value,
        bb: formsBBSell.value,
        bb_squeeze: formsBBSqueezeSell.value,
        stochrsi: formsStochasticRsiSell.value,
        mfi: formsMoneyFlowIndexSell.value,
        ao: formsAwesomeOscillatorIndexSell.value,
        kc: formsKeltnerSell.value,
        kama: formsKaufmanAdaptiveMovingAverageSell.value,
        ichimoku: formsIchimokuSell.value,
        accumulation_distribution: formsAccumulationDistributionSell.value,
      };
      return generateOutputData(customSignalDataSell, obj, Object.keys(obj));
    });

    function findMinimumTimePeriod(obj) {
      for (let key in obj) {
        obj[key].forEach((i) => {
          if (
            i.time_period === "half_hourly" &&
            miniumTimeperiod.value !== "half_hourly"
          ) {
            miniumTimeperiod.value = "half_hourly";
          } else if (
            i.time_period === "hourly" &&
            miniumTimeperiod.value !== "half_hourly" &&
            miniumTimeperiod.value !== "hourly"
          ) {
            miniumTimeperiod.value = "hourly";
          } else if (
            i.time_period === "daily" &&
            miniumTimeperiod.value !== "half_hourly" &&
            miniumTimeperiod.value !== "hourly" &&
            miniumTimeperiod.value !== "daily"
          ) {
            miniumTimeperiod.value = "daily";
          } else if (
            i.time_period === "weekly" &&
            miniumTimeperiod.value !== "half_hourly" &&
            miniumTimeperiod.value !== "hourly" &&
            miniumTimeperiod.value !== "daily" &&
            miniumTimeperiod.value !== "weekly"
          ) {
            miniumTimeperiod.value = "weekly";
          } else if (
            i.time_period === "monthly" &&
            miniumTimeperiod.value !== "half_hourly" &&
            miniumTimeperiod.value !== "hourly" &&
            miniumTimeperiod.value !== "daily" &&
            miniumTimeperiod.value !== "weekly" &&
            miniumTimeperiod.value !== "monthly"
          ) {
            miniumTimeperiod.value = "monthly";
          }
        });
      }
    }

    const submitSetup = async () => {
      // reset miniumTimePeriod before calculation of minimum time period.
      if (props.editModel) miniumTimeperiod.value = "daily";
      try {
        $q.loading.show({
          message: "This will take few seconds to minute. Please wait...",
          boxClass: "bg-grey-2 text-grey-9",
          spinnerColor: "primary",
        });
        let setup = {};
        let indicators = [];
        if (setup_type.value == "buy") {
          setup = {
            buy_setup: outputData.value,
          };
          indicators = Object.keys(setup?.buy_setup?.indicators);
          let obj = setup.buy_setup.indicators;
          findMinimumTimePeriod(obj);
        } else if (setup_type.value == "sell") {
          setup = {
            sell_setup: outputSellData.value,
          };
          indicators = Object.keys(setup?.sell_setup?.indicators);
          let obj = setup.sell_setup.indicators;
          findMinimumTimePeriod(obj);
        } else {
          setup = {
            buy_setup: outputData.value,
            sell_setup: outputSellData.value,
          };
          indicators = Object.keys(setup?.sell_setup?.indicators).concat(
            Object.keys(setup?.buy_setup?.indicators)
          );
          let buyObj = setup.sell_setup.indicators;
          findMinimumTimePeriod(buyObj);
          let sellObj = setup.buy_setup.indicators;
          findMinimumTimePeriod(sellObj);
        }
        if (props.editModel) {
          context.emit("editModel", {
            name: modelName.value,
            setup: setup,
            setup_type: setup_type.value,
            min_time_period: miniumTimeperiod.value,
            model_id: props.model_id,
            name: props.model_name,
            above_avg_vol: above_avg_vol.value,
          });
        } else {
          if (props.backTest) {
            context.emit("submitBackTest", {
              setup_type: setup_type.value,
              setup: setup,
              above_avg_vol: above_avg_vol.value,
            });
            context.emit("indicators", indicators);
          } else {
            if (!props.isSaveModelPage) {
              try {
                try {
                  const res = await customSignalProV2New({
                    ...setup,
                    setup_type: setup_type.value,
                    above_avg_vol: above_avg_vol.value,
                  });
                  customTableData.value = res.data;
                  customBuySignal.value = customTableData.value.buy_signals;
                  customSellSignal.value = customTableData.value.sell_signals;
                  symbol.value = customBuySignal.value[0];
                  loading.value = false;
                  $q.loading.hide();
                  context.emit("buySignals", customBuySignal.value);
                  context.emit("sellSignals", customSellSignal.value);
                  context.emit("indicators", indicators);
                } catch (e) {
                  const { response } = e;
                  $q.notify({
                    color: "negative",
                    type: "negative",
                    message: response?.data?.message,
                  });
                  $q.loading.hide();
                }
              } catch {
                $q.loading.hide();
              }
            } else {
              await store
                .dispatch("custom/onPostcustomSignalProV2NewSave", {
                  name: modelName.value,
                  setup: setup,
                  setup_type: setup_type.value,
                  min_time_period: miniumTimeperiod.value,
                  above_avg_vol: above_avg_vol.value,
                })
                .then((res) => {
                  $q.notify({
                    color: "secondary",
                    type: "posetive",
                    message: "Model has been saved suceessfully",
                  });
                })
                .catch((e) => {
                  $q.loading.hide();
                  $q.notify({
                    type: "negative",
                    message: e?.response?.data?.message,
                  });
                });
              miniumTimeperiod.value = "daily";
              modelName.value = "";
              $q.loading.hide();
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    const findIndexByKey = (keyToFind) => {
      const indicatorKeys = Object.keys(outputData.value.indicators);
      const index = indicatorKeys.indexOf(keyToFind);
      return index;
    };

    const findIndexByKeySell = (keyToFind) => {
      const indicatorKeys = Object.keys(outputSellData.value.indicators);
      const index = indicatorKeys.indexOf(keyToFind);
      return index;
    };

    return {
      cursorPointerNone,
      above_avg_vol,
      miniumTimeperiod,
      submitSetup,
      avaliablePackageList,
      savedCustomSignalPro,
      setup_type,
      from_date,
      to_date,
      customSignalDataBuy,
      customSignalDataSell,
      signal_type,
      formsRsi,
      formsRsiCrossover,
      formsSma,
      formsSmaCrossover,
      formsMacd,
      formsEma,
      formsEmaCrossover,
      formsSupertrend,
      formsDI,
      formsParabolicSar,
      formsBB,
      formsBBSqueeze,
      formsMoneyFlowIndex,
      formsAwesomeOscillatorIndex,
      formsKaufmanAdaptiveMovingAverage,
      formsStochasticRsi,
      formsKeltner,
      formsRsiSell,
      formsRsiCrossoverSell,
      formsSmaSell,
      formsSmaCrossoverSell,
      formsMacdSell,
      formsEmaSell,
      formsEmaCrossoverSell,
      formsSupertrendSell,
      formsDISell,
      formsParabolicSarSell,
      formsBBSqueezeSell,
      formsMoneyFlowIndexSell,
      formsAwesomeOscillatorIndexSell,
      formsKaufmanAdaptiveMovingAverageSell,
      formsStochasticRsiSell,
      formsKeltnerSell,
      formsIchimokuSell,
      formsIchimoku,
      formsAccumulationDistributionSell,
      formsAccumulationDistribution,
      outputData,
      outputSellData,
      findIndexByKey,
      findIndexByKeySell,
      customTableData,
      customBuySignal,
      customSellSignal,
      symbol,
      loading,
      modelName,
      saveModelDialog,
      savedCustomSignalData,
      optionSectors,
      selectedSector,
      fundamentalScanData,
      visible,
    };
  },
};
</script>
